<!--
 * @Description: KaDa图画阅读馆-绘本
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/pc/src/views/introduction/BooksDesc.vue
 * @Date: 2020-12-17 10:47:50
-->
<template>
    <div class='module-cont module-books'>
        <div class="text-cont">
            <div class="title-style"><span class="fzlty-zc">KaDa</span>互动阅读馆-AI轻课</div>
            <div class="desc-style">15000+知识视频，引领孩子从泛读走向精读</div>
        </div>
        <div class="icon-list-cont">
            <div class="icon-item" v-for="(item, index) in iconList" :key="index">
                <img :src="item.imgUrl" alt="">
                <p v-html="item.desc" class="icon-desc"></p>
            </div>
        </div>
        <img class="mobile-icon" :src="mobileImg" alt="">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                starImg: '//cdn.hhdd.com/frontend/as/i/7a4940ed-e912-5d63-916e-5a980c6ac606.png',
                mobileImg: '//cdn.hhdd.com/frontend/as/i/899fec17-9110-53bd-980d-9d3f0d7ab3a0.png',
                kadaImg: '//cdn.hhdd.com/frontend/as/i/2ac042e6-0046-5af3-a72c-7d142103d869.png',
                iconList: [
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/27a77028-376a-5396-8799-ab4d504e64b8.png',
                        desc: 'Q版设计<br>增强学习代入感'
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/5b5ac4c0-e555-515b-b92d-11267ba3e84d.png',
                        desc: '童言童语<br>更易孩子理解吸收'
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/7e9f2edf-2427-506b-9ee3-c4af0e62732f.png',
                        desc: '多感官互动<br>充分激活孩子脑力'
                    }
                ]
            }
        },
    }
</script>

<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.module-books
    background #fff
    position relative
    // margin-top px2rem2(44)
    padding px2rem2(44) px2rem2(16)
    .text-cont
        text-align center
        .title-style
            color #3F3F3F
            font-size px2rem2(18)
            font-weight 600
        .desc-style
            margin-top px2rem2(6)
            color #3F3F3F
            font-size px2rem2(12)
           
    //         opacity .8
    // .mobile-icon
      
    .icon-list-cont
        margin px2rem2(20) 0
        display flex
        flex-wrap nowrap
        justify-content space-around
       
        .icon-item
            padding px2rem2(10)
            background #F6F8FB
            border-radius px2rem2(16)
            img
                width px2rem2(50)
                height px2rem2(50)
                margin 0 auto
        div:nth-child(2)
            margin 0 px2rem2(13)
        .icon-desc
            text-align center
            color #666666
            font-size px2rem2(10)
</style>



// WEBPACK FOOTER //
// src/views/home/CourseDesc.vue